import { css } from "lit";
import { customElement } from "lit/decorators.js";
import { Paragraph } from "@/components/paragraph";

@customElement("eko-empty-state-intro")
class EmptyStateIntro extends Paragraph {
  static styles = [
    ...Paragraph.styles,
    css`
      :host {
        --_eko-empty-state-intro-text-color: var(
          --eko-empty-state-intro-text-color,
          oklch(var(--eko-t-color-text-weak))
        );

        color: var(--_eko-empty-state-intro-text-color);
      }
    `,
  ];
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-empty-state-intro": EmptyStateIntro;
  }
}

export default EmptyStateIntro;
